// Exports
export default {
	"island": "island_LY5DN"
};
